function loadKemanusiaan(view) {
    return () => import( /* webpackChunkName: "proyekKemanusiaan-[request]" */ `../../views/KampusMerdeka/ProyekKemanusiaan/${view}.vue`)
}
function loadBimbinganKemanusiaan(view) {
    return () => import( /* webpackChunkName: "bimbinganKemanusiaan-[request]" */ `../../views/KampusMerdeka/BimbinganProyekKemanusiaan/${view}.vue`)
}

const kemanusiaanRoute = [
    {
        path: '/kampus-merdeka/kemanusiaan',
        name: 'ProyekKemanusiaanMahasiswaView',
        meta: {
            requiresAuth: true,
            roleVerif: false,
            role: []
        },
        component: loadKemanusiaan('MahasiswaView')
    },
    {
        path: '/kampus-merdeka/kemanusiaan-verify',
        name: 'ProyekKemanusiaanVerifyView',
        meta: {
            requiresAuth: true,
            roleVerif: false,
            role: []
        },
        component: loadKemanusiaan('ProyekKemanusiaanVerifyView')
    },
    {
        path: '/kemanusiaan-logbook/:id',
        name: 'LogbookProyekKemanusiaan',
        meta: {
            requiresAuth: true,
            roleVerif: false,
            role: []
        },
        component: loadKemanusiaan('LogbookProyekKemanusiaan')
    },
    {
        path: '/kemanusiaan-dosbim/:kemanusiaan_id',
        name: 'DosbimProyekKemanusiaan',
        meta: {
            requiresAuth: true,
            roleVerif: false,
            role: []
        },
        component: loadKemanusiaan('ProyekKemanusiaanAdvisor')
    },
    {
        path: '/kemanusiaan-rubric',
        name: 'RubricProyekKemanusiaan',
        meta: {
            requiresAuth: true,
            roleVerif: true,
            role: ['kaprodi','sekprodi']
        },
        component: loadKemanusiaan('RubricCategory')
    },
    {
        path: '/kemanusiaan-rubric/:category_id',
        name: 'RubricFieldProyekKemanusiaan',
        meta: {
            requiresAuth: true,
            roleVerif: true,
            role: ['kaprodi','sekprodi']
        },
        component: loadKemanusiaan('RubricField')
    },
    {
        path: '/proyek-kemanusiaan-exam/:id',
        meta: {
            requiresAuth: true,
            roleVerif: false,
            role: []
        },
        component: loadKemanusiaan('MainViewExam'),
        children: [
            {
                path: '',
                name: 'Ujian Proyek Kemanusiaan',
                component: loadKemanusiaan('ExamDetail')
            },
            {
                path: 'institusi',
                name: 'Penilaian Institusi',
                component: loadKemanusiaan('InstitusiRubric')
            },
            {
                path: 'lecture',
                name: 'Penilaian Dosen Pembimbing Proyek Kemanusiaan',
                component: loadKemanusiaan('LectureRubric')
            },
            {
                path: 'result',
                name: 'Nilai Proyek Kemanusiaan',
                component: loadKemanusiaan('KemanusiaanResult')
            }
        ]
    },
    {
        path: '/kampus-merdeka/dosen/bimbingan/proyek-kemanusiaan/:student_id',
        name: 'MyStudentGuidancesProyekKemanusiaan',
        meta: {
            requiresAuth: true,
            roleVerif: true,
            role: ['kaprodi','administrator','sekprodi','dosen', 'kalab', 'wadek', 'kadep']
        },
        component: loadBimbinganKemanusiaan('ListBimbinganMahasiswa')
    },
    {
        path: '/kampus-merdeka/dosen/bimbingan/proyek-kemanusiaan',
        name: 'MyGuidanceStudentsProyekKemanusiaan',
        meta: {
            requiresAuth: true,
            roleVerif: true,
            role: ['kaprodi','administrator','sekprodi','dosen', 'kalab', 'wadek', 'kadep']
        },
        component: loadBimbinganKemanusiaan('ListMahasiswaBimbingan')
    },
    {
        path: '/kampus-merdeka/dosen/bimbingan/proyek-kemanusiaan/:student_id/:guidance_id',
        name: 'ResponseMyStudentGuidanceProyekKemanusiaan',
        meta: {
            requiresAuth: true,
            roleVerif: true,
            role: ['kaprodi','administrator','sekprodi','dosen', 'kalab', 'wadek', 'kadep']
        },
        component: loadBimbinganKemanusiaan('ResponseBimbinganMahasiswa')
    },
    {
        path: '/kampus-merdeka/mahasiswa/bimbingan/proyek-kemanusiaan/:guidance_id',
        name: 'ResponseGuidanceProyekKemanusiaan',
        meta: {
            requiresAuth: true,
            roleVerif: true,
            role: ['mahasiswa']
        },
        component: loadBimbinganKemanusiaan('ResponseBimbinganMahasiswa')
    },
    {
        path: '/kampus-merdeka/mahasiswa/bimbingan/proyek-kemanusiaan',
        name: 'ListBimbinganProyekKemanusiaan',
        meta: {
            requiresAuth: true,
            roleVerif: true,
            role: ['mahasiswa']
        },
        component: loadBimbinganKemanusiaan('ListBimbingan')
    },
    {
        path: '/kampus-merdeka/form/bimbingan/proyek-kemanusiaan',
        name: 'FormBimbinganProyekKemanusiaan',
        meta: {
            requiresAuth: true,
            roleVerif: true,
            role: ['mahasiswa']
        },
        component: loadBimbinganKemanusiaan('FormBimbingan')
    },
    {
        path: '/proyek-kemanusiaan-exam',
        name: 'ProyekKemanusiaanVerifyExam',
        meta: {
            requiresAuth: true,
            roleVerif: true,
            role: ['kaprodi','administrator','sekprodi','dosen', 'kalab', 'wadek', 'kadep']
        },
        component: loadKemanusiaan('VerifyExam')
    },
    {
        path: '/konversi-proyek-kemanusiaan',
        name: 'StudentConvertionViewKemanusiaan',
        meta: {
            requiresAuth: true,
            roleVerif: true,
            role: ['kaprodi','administrator','sekprodi']
        },
        component: loadKemanusiaan('StudentConvertionView')
    },
    {
        path: '/konversi-proyek-kemanusiaan/mata-kuliah/:id',
        name: 'ConvertionViewKemanusiaan',
        meta: {
            requiresAuth: true,
            roleVerif: true,
            role: ['kaprodi','administrator','sekprodi']
        },
        component: loadKemanusiaan('ConvertionView')
    },
    {
        path: '/konversi-proyek-kemanusiaan/mata-kuliah/:id/TU',
        name: 'ConvertionViewKemanusiaanAdmin',
        meta: {
            requiresAuth: true,
            roleVerif: true,
            role: ['administrator', 'mahasiswa']
        },
        component: loadKemanusiaan('ConvertionViewAdmin')
    },
]

export default kemanusiaanRoute